/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sklik_Test_OkInputs */

const cs_sklik_test_ok = /** @type {(inputs: Sklik_Test_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sklik token OK`)
};

const en_sklik_test_ok = /** @type {(inputs: Sklik_Test_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sklik token OK`)
};

/**
* | output |
* | --- |
* | "Sklik token OK" |
*
* @param {Sklik_Test_OkInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sklik_test_ok = /** @type {((inputs?: Sklik_Test_OkInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sklik_Test_OkInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sklik_test_ok(inputs)
	return cs_sklik_test_ok(inputs)
});